import { Badge, HintDot } from "baseui/badge";
import { LabelSmall } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { HorizontalStackPanel } from "../../../../components/Layout/StackPanel";
import { getLongDayName, getWeekDays, isToday } from "./utils";
import { styled, useStyletron } from "baseui";
import { useGetLanguage } from "../../../../hooks/useGetLanguage";
import { TDailySchedule, TDailyScheduleEntry } from "../types";
import DayItem from "./DayItem";
import { TScheduler } from "../types";

const ListView: React.FC<{ 
    now: Date, 
    days: TDailySchedule[], 
    app: TScheduler,
    onEventDeleted: (weekday: number, event: TDailyScheduleEntry) => void,
    onEventChanged: (weekday: number, event: TDailyScheduleEntry) => void,
 }> = ({ now, days, app, onEventDeleted, onEventChanged  }) => {

    const weekDays = getWeekDays();
    const { language } = useGetLanguage();
    const [css, theme] = useStyletron();

    return (<ItemsContainer>
        {weekDays.map((x) => {
            const today = isToday(x, now);
            const dayName = getLongDayName(x, language);
            const items = days.find(v => v.weekday === x)?.entries ?? []
            const empty = items?.length === 0;
            return (
                <DayContainer>
                    <div className={css({ gridRow: 0 })}>
                        <HorizontalStackPanel>
                            {empty ? <HintDot horizontalOffset="-10px" color="warning"><LabelSmall>{dayName}</LabelSmall></HintDot> : <LabelSmall>{dayName}</LabelSmall>}
                            {today && <>{' '}<Badge color={'positive'} content={<FormattedMessage id='Devices.Today' defaultMessage={'Today'}></FormattedMessage>} hierarchy="secondary" shape="pill" /></>}
                        </HorizontalStackPanel>
                    </div>
                    <DayItem onEntryChanged={onEventChanged} onEntryDeleted={onEventDeleted} now={now}  app={app} dayOfWeek={x} items={items}></DayItem>
                </DayContainer>
            )
        }
        )}
    </ItemsContainer>);
};

export default ListView;

const ItemsContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    width: '100%',
    columnGap: $theme.sizing.scale500,
    overflowX: 'auto',

}));

const DayContainer = styled<'div', {}>("div", ({ $theme }) => ({

    width: '100%',
    display: 'grid',
    gridTemplateRows: '45px 1fr',

}));